import { AfterContentInit, Component, Input } from '@angular/core';
import { isEmpty } from 'ramda';
import { AssignmentServiceProgress, HhgIdentity, Workflow } from "../../../entities-state/types";
import { AppStore } from '@k2/common/state/services/app-store';
import { StaffAppState } from '@k2/staff/staff-app-state';
import { select } from '@ngrx/store';
import { getHhgFromAssignmentByAssignmentServiceInstanceId } from '@k2/common/assignments-state/selectors';
import { ClientAssignmentComponent } from '@k2/staff/content/clients/client/assignment/client-assignment.component';
import { catchError, filter, map, take, timeout } from 'rxjs/operators';
import { ActionDispatcher } from '@k2/common/state/services/action-dispatcher';
import { Navigate } from '@k2/common/routing/actions';
import { of } from 'rxjs';
import { AddressesPayload } from '@k2/staff/content/clients/client/assignment/hhg/overview/addresses/list/addresses-list.component';

@Component({
  selector: 'assignment-services',
  templateUrl: 'assignment-services.component.html',
  styleUrls: ['assignment-services.component.scss'],
  standalone: false
})
export class AssignmentServicesComponent implements AfterContentInit {
  @Input() workflows: Workflow[];
  @Input() hhgWorkflow: Workflow;

  clickedServiceId: number;

  constructor(
    private assignmentRef: ClientAssignmentComponent,
    private store: AppStore<StaffAppState>,
    private actions: ActionDispatcher
  ) {
  }

  ngAfterContentInit() {
    // 7 is Visa / Immigration
    this.clickedServiceId = 7;
  }

  toServiceLink = (serviceId: number) => {
    switch (serviceId) {
      case 26:
        return './hhg';
      case 27:
        return './hhg/storage';
      case 28:
        return './hhg/insurance';
      default:
        return ['./services', serviceId];
    }
  };

  navigateToHhg = (serviceId: number, assignmentServiceInstanceId: number): void => {
    if (assignmentServiceInstanceId) {
      this.store.pipe(
        select(
          getHhgFromAssignmentByAssignmentServiceInstanceId(this.assignmentRef.identity.assignmentId, assignmentServiceInstanceId)
        ),
        filter(result => result !== undefined),
        take(1),
        timeout(500),
        catchError(() => of({ id: null })),
        map((hhg: HhgIdentity) => hhg.id)
      ).subscribe(hhgId => {
        if (hhgId) {
          this.actions.dispatch(new Navigate(['./hhg', hhgId]));
        } else {
          this.actions.dispatch(new Navigate(this.toServiceLink(serviceId)));
        }
      });
    }
  };

  get hasServices(): boolean {
    return this.hhgWorkflow != null || this.workflows.some(workflow => !isEmpty(workflow.services));
  }

  isVisaImmigrationService(id: number): boolean {
    return id === 7;
  }

  showAllServiceStatuses(id: number): boolean {
    return this.clickedServiceId === id;
  }

  onServiceOpenClick(id: number) {
    this.clickedServiceId = this.showAllServiceStatuses(id) ? null : id;
  }

  getServiceStatus(progress: AssignmentServiceProgress[]): string {
    if (!progress.length || progress.every(s => s.value === 'Not started')) {
      return 'Not started';
    } else if (progress.every(s => s.value === 'Completed')) {
      return 'Completed';
    } else {
      return 'In progress';
    }
  }

  hasAddresses(addresses: AddressesPayload) {
    return !!(addresses && addresses.hhgOriginAddress?.address && addresses.hhgDestinationAddresses.length);
  }
}
